module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel md-scrollbar md-theme-default",
    attrs: {
      "id": "users-actions"
    }
  }, [_c('md-content', {
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('user-menu'), _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "md-flex",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('md-table', {
    attrs: {
      "md-theme": "white"
    }
  }, _vm._l((_vm.actions), function(action) {
    return _c('md-table-row', {
      key: action.id,
      class: (_vm.$route.params.action_code && _vm.$route.params.action_code == action.code) ? 'action-row hovered' : 'action-row'
    }, [_c('md-table-cell', [_c('div', {
      staticClass: "row-container"
    }, [_c('span', {
      staticClass: "md-layout-row md-gutter"
    }, [_c('span', {
      staticClass: "md-flex name"
    }, [_vm._v(_vm._s(action.name + ' (' + action.code + ')'))])]), (_vm.usersGroups && _vm.usersGroups.length && action.groups) ? _c('div', {
      staticClass: "action-groups",
      class: {
        'loading': _vm.loading
      }
    }, [_c('md-button', {
      staticClass: "md-primary md-icon-button md-dense small",
      on: {
        "click": function($event) {
          _vm.save(action)
        }
      }
    }, [_c('md-icon', [_vm._v("check")]), _c('md-tooltip', {
      attrs: {
        "md-direction": "bottom",
        "md-delay": "500"
      }
    }, [_vm._v("Сохранить")])], 1), _c('md-field', [_c('md-select', {
      attrs: {
        "name": "groups",
        "id": "groups",
        "md-dense": "md-dense",
        "multiple": "multiple",
        "placeholder": "Группы пользователей",
        "disabled": _vm.loading
      },
      model: {
        value: (action.groups),
        callback: function($$v) {
          _vm.$set(action, "groups", $$v)
        },
        expression: "action.groups"
      }
    }, _vm._l((_vm.usersGroups), function(group) {
      return _c('md-option', {
        key: group.id,
        attrs: {
          "value": group.code
        }
      }, [_vm._v(_vm._s(group.name))])
    }))], 1)], 1) : _vm._e()])])], 1)
  }))], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cad4636","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/users/views/Actions.vue
// module id = 1094
// module chunks = 0